import {
  Button,
  Col,
  DatePicker,
  Empty,
  Flex,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Spin,
  Typography,
} from "antd";
import { FileDoneOutlined } from "@ant-design/icons";
import { ExamsListItem } from "@components";
import { useNavigate } from "react-router-dom";
const { Search } = Input;
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useGetExamPeriods } from "@hooks";
import { Query } from "@types";
import { useState } from "react";
import {FixedSizeList} from 'react-window';
import { getKeycloakRealm } from "@/components/helpers";

export const ExamPeriodPage = () => {
  const navigate = useNavigate();
  const {t} = useTranslation();
  const [query, setQuery] = useState<Query>({sort: "dateCreated", direction: "desc"});

  const {data, isLoading} = useGetExamPeriods(query);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 1 }}
    >
      <Row gutter={[32, 32]}>
        <Col xl={5} lg={5} md={24} sm={24} xs={24}>
          <Space direction="vertical" style={{ display: "flex" }}>
            <Search
              placeholder={t("pages.examPeriods.searchFilter")}
              onSearch={(value) => setQuery({ ...query, examTitle: value })}
              style={{ width: "100%" }}
            />
            <Typography.Title level={4} style={{ marginBottom: 0 }}>
              {t("pages.examPeriods.dateFilter")}
            </Typography.Title>
            <DatePicker
              format={"DD.MM.YYYY"}
              onChange={(_, dateString) => {
                setQuery({ ...query, dateOfExamPeriod: dateString as string });
              }}
              style={{ width: "100%" }}
            />
            <Typography.Title level={4} style={{ marginBottom: 0 }}>
              {t("pages.examPeriods.statusFilter")}
            </Typography.Title>
            <Space direction="vertical">
              <Radio.Group
                onChange={(e) => {
                  setQuery({ ...query, examTermState: e.target.value });
                }}
              >
                <Space direction="vertical">
                  <Radio value={undefined}>
                    {t("pages.examPeriods.statusFilterAll")}
                  </Radio>
                  <Radio value={4}>
                    {t("pages.examPeriods.statusFilterNotStarted")}
                  </Radio>
                  <Radio value={5}>
                    {t("pages.examPeriods.statusFilterStarted")}
                  </Radio>
                  <Radio value={6}>
                    {t("pages.examPeriods.statusFilterFinished")}
                  </Radio>
                </Space>
              </Radio.Group>
            </Space>
          </Space>
        </Col>
        <Col xl={19} lg={19} md={24} sm={24} xs={24}>
          <Flex justify="space-between">
            <Button
              id="new-exam-period-button"
              type="primary"
              onClick={() => navigate(`/${getKeycloakRealm}/exam-periods/new`)}
              icon={<FileDoneOutlined />}
            >
              {t("pages.examPeriods.newExamPeriodButton")}
            </Button>
            <Select
              id="sort_filter"
              style={{ width: 200 }}
              variant="filled"
              defaultValue={0}
              onChange={(value) => {
                if (value === 0) {
                  setQuery({
                    ...query,
                    sort: "dateCreated",
                    direction: "desc",
                  });
                } else {
                  setQuery({ ...query, sort: "dateCreated", direction: "asc" });
                }
              }}
              options={[
                { value: 0, label: t("pages.bankPool.sortFilterNew") },
                { value: 1, label: t("pages.bankPool.sortFilterOld") },
                // { value: 12, label: t("pages.bankPool.sortFilterDate") },
              ]}
            />
          </Flex>
          <Spin spinning={isLoading}>
            {data?.items.length > 0 ? (
              <motion.div
                key={"list"}
                style={{ paddingTop: 12 }}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <FixedSizeList
                  itemCount={data?.items.length || 0}
                  width={"100%"}
                  height={window.innerHeight - 80}
                  itemSize={180}
                >
                  {({ index, style }) => {
                    const item = data?.items[index];
                    return (
                      <div style={style} key={index}>
                        <ExamsListItem examPeriod={item} />
                      </div>
                    );
                  }}
                </FixedSizeList>
              </motion.div>
            ) : (
              <motion.div
                key={"empty"}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
              >
                <Empty />
              </motion.div>
            )}
          </Spin>
        </Col>
      </Row>
    </motion.div>
  );
};
